import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '../icon-prop-types';
import { IconSizes } from '../icon-prop-types';

const TEST_ID = 'caret-up-down-icon';

export const CaretUpDownIcon = ({ fill = 'black', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 10 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            data-testid={TEST_ID}
        >
            <path className={fillStyles} d="M5 18L0 12H10L5 18ZM10 6H0L5 0L10 6Z" />
        </svg>
    );
};
CaretUpDownIcon.TEST_ID = TEST_ID;
